import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { Button } from "../atoms/button";
import useMedia from 'use-media';
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

import { SoloInputConfirmReserver } from "../molecules/soloInputConfirmReserver";
import { PlanListConfirm } from "../molecules/planListConfirm";
import { Line } from '../atoms/line';
import { GolfFooterContainer } from "./golfFooterContainer";
import { Label } from '../atoms/label';
import { soloReserveGolfPlanAddCommit, versionGetApi } from "../../const";
import { connect, useStore } from "react-redux";
import common from "../../resources/js/common/common"
import { apiKeyCheck } from '../../const';
import '../../resources/css/soloReserve/golfSoloConfirm.css'
import commonUtil from '../../common/commonUtil';
import { SoloInputConfirmStartTime } from '../molecules/soloInputConfirmStartTime';
import { useRtoaster } from '../../hooks/useRtoaster';

const GolfSoloConfirmContainer = (props) => {
    const {
        golfSoloTeetime,
        golfSoloSearchData,
        login,
        soloKaiinken,
    } = props;

    const history = useHistory();
    const store = useStore();


    const [errorMessage, setErrorMessage] = useState(true);
    const [otherCourseCheck, setOtherCourseCheck] = useState(true);

    //レスポンシブ対応
    const isWideTablet = useMedia({ maxWidth: '960px' });

    const processing = useRef(false);

    // rtoasterタグ生成
    const customParam = {
        "sisetucd": golfSoloSearchData.golfCourseId,
        "riyodat": golfSoloSearchData.playDate,
        "keiyakuno": golfSoloSearchData.contractNo,
        "packcd": golfSoloSearchData.planId,
        "packnam": golfSoloSearchData.planName,
        "coursecd": golfSoloTeetime.courseId,
        "startjikan": golfSoloTeetime.startTime,
    }
    useRtoaster(history.location.pathname, customParam);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);


        common.scrollWindowTop();
    }, []);

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    const onClickBack = () => {
        history.push("/reserve/golf/soloUserInput");
    };

    const onClickReserve = (e) => {
        e.preventDefault();

        if (processing.current) {
            return;
        }
        processing.current = true;

        const loginUserInfo = login.loginUserInfo;

        const req = {
            teetimeId: golfSoloTeetime.teetimeId,
            golfCourseId: golfSoloTeetime.golfCourseId,
            ttbLoginUserId: golfSoloTeetime.playerInfo?.ttbLoginUserId,
            familyName: golfSoloTeetime.playerInfo?.familyName,
            firstName: golfSoloTeetime.playerInfo?.firstName,
            familyNameKana: golfSoloTeetime.playerInfo?.familyNameKana,
            firstNameKana: golfSoloTeetime.playerInfo?.firstNameKana,
            email: golfSoloTeetime.playerInfo?.mailAddress,
            addressPref: golfSoloTeetime.playerInfo?.addressPref,
            contactPhoneNumber: golfSoloTeetime.playerInfo?.phone,
            memberCode: golfSoloSearchData.contractNo,
            planId: golfSoloTeetime.planId,
            planName: golfSoloTeetime.planName,
            remark: golfSoloTeetime.playerInfo?.remark,
            playerName: golfSoloTeetime.playerInfo?.playerName,
            playerNameKana: golfSoloTeetime.playerInfo?.playerNameKana,
            genderType: golfSoloTeetime.playerInfo?.genderType,
            playDate:golfSoloTeetime.playDate,
            applicationFamilyName:golfSoloTeetime.playerInfo?.applicationFamilyName,
            applicationFirstName:golfSoloTeetime.playerInfo?.applicationFirstName,
            courseName:golfSoloTeetime.courseName,
            startTime:golfSoloTeetime.startTime,
            isCaddy:golfSoloTeetime.planInfo?.isCaddy,
            cartType:golfSoloTeetime.planInfo?.cartType,
            isLunch:golfSoloTeetime.planInfo?.isLunch,
            is2Sum:golfSoloTeetime.planInfo?.is2Sum,
            content:golfSoloTeetime.planInfo?.content,
            planRemark: golfSoloTeetime.planInfo?.planRemark,
            price:golfSoloTeetime.planInfo?.price,
            golfTax:golfSoloTeetime.planInfo?.golfTax,
            tax:golfSoloTeetime.planInfo?.tax,
            priceTotal:golfSoloTeetime.planInfo?.priceTotal,
            otherfee:golfSoloTeetime.planInfo?.otherfee,
            otherfeeMemo:golfSoloTeetime.planInfo?.otherfeeMemo,
            extraFee2Bag:golfSoloTeetime.planInfo?.extraFee2Bag,
            extraFee3Bag:golfSoloTeetime.planInfo?.extraFee3Bag,
            reservationQualification:golfSoloTeetime.planInfo?.reservationQualification,
            point:golfSoloTeetime.planInfo?.point,
            
        };

        common.doPost(soloReserveGolfPlanAddCommit, req, afterSoloReserveGolfPlanAddCommit);
    };

    const afterSoloReserveGolfPlanAddCommit = (res) => {
        // デバッグ
        if (res.data.resultCode == 0) {
            // 画面遷移
            history.push("/reserve/golf/soloComplete");
        }
        else if (res.data.resultCode == 99) {
            // 別コースの予約を登録実施。
            setOtherCourseCheck(false);
            window.scroll({ top: 0, behavior: 'smooth' })
        }
        else {
            setErrorMessage(false);
            window.scroll({ top: 0, behavior: 'smooth' })
        }
        processing.current = false;
    }

    return (
        <div className='soloConfirm_top' >
            <div className='soloConfirm_breadCrumb'>
                <Link to={"/reserve/top"} className='soloConfirm_link' >HOME</Link>
                <Label label=">" className='soloConfirm_breadCrumbArrow' />
                <Link to={"/reserve/golf/soloSearch"} className='soloConfirm_link' >ゴルフ一人予約</Link>
                <Label label=">" className='soloConfirm_breadCrumbArrow' />
                <Link to={"/reserve/golf/soloStartTime"} className='soloConfirm_link' >スタート時間</Link>
                <Label label=">" className='soloConfirm_breadCrumbArrow' />
                <Link to={"/reserve/golf/soloUserInput"} className='soloConfirm_link'>利用者入力</Link>
                <Label label=">" className='soloConfirm_breadCrumbArrow' />
                <Label label="入力内容確認" className='soloConfirm_link' />
            </div>
            <div className='soloConfirm_base'>
                <>
                    <div className='soloConfirm_planList'>
                        {!errorMessage ?
                            <div className='soloConfirm_errorDiv'>予約に失敗しました<br />再度検索してください</div>
                            : null}
                        {!otherCourseCheck ?
                            <div className='soloConfirm_errorDiv'>接続エラーが発生しました。<br />お手数ですがHOME画面より再度お試しください。</div>
                            : null}
                        <PlanListConfirm label1={"ゴルフ場"} label2={golfSoloSearchData.golfCourseName} />
                        <PlanListConfirm label1={"プラン"} label2={golfSoloTeetime.planName} />
                        <PlanListConfirm label1={"プレー日"} label2={commonUtil.getStringFromDateJpnGolf(golfSoloSearchData?.playDate)} />
                        <div className='soloConfirm_form'>
                            <SoloInputConfirmReserver
                                reserverInfo={golfSoloTeetime?.playerInfo}
                            />
                        </div>
                    </div>
                    <div className='soloConfirm_form'>
                        <SoloInputConfirmStartTime
                            label1="スタート時間"
                            label2={golfSoloTeetime.courseName + "/" + golfSoloTeetime.startTime + "スタート"} />
                        <Line style={isWideTablet ? styles.line2 : styles.line} key={"line0"} />
                    </div>
                </>
                <div className='soloConfirm_btnArea'>
                    <Button buttonText="戻る" className="soloConfirm_backBtn" onClick={onClickBack} />
                    <Button buttonText="この内容で予約する" className='soloConfirm_reserveBtn' onClick={onClickReserve} />
                </div>
                <div className='soloConfirm_topBtnArea' >
                    <Link className='soloConfirm_linkTop' to="/reserve/golf/soloSearch" >ゴルフ一人予約TOPに戻る</Link>
                </div>
            </div>
            <div style={styles.footer}>
                <GolfFooterContainer />
            </div>
        </div >
    )
}

const styles = {
    line: {
        width: "100%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "10px auto 0px",
    },
    line2: {
        width: "90%",
        border: "1px solid rgb(204, 204, 204)",
        borderWidth: "1px 0px 0px 0px",
        margin: "15px auto 0px",
    },
    footer: {
        color: "#ffffff",
        marginTop: "100px",
    },
}

const mapStateToProps = (state) => {
    return {
        golfSoloTeetime: state.golfSoloTeetime,
        golfSoloSearchData: state.golfSoloSearchData,
        login: state.login,
        soloKaiinken: state.soloKaiinken,
    };
};

export default connect(mapStateToProps, null)(GolfSoloConfirmContainer);